<ng-template #content let-c="close" let-d="dismiss">
  <ng-content></ng-content>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-settings/achoo-modal/achoo-modal.component.html